module.exports = __webpack_public_path__ + "static/media/KalasSumergible.21cdffbc.pdf";